<template>
  <div class="yt-video">
    <div class="yt-container" @click="openVideo">
      <div class="yt-thumbnail-container">
        <img
          class="yt-thumbnail"
          :src="`//img.youtube.com/vi/${videoId}/mqdefault.jpg`"
        />
      </div>
      <div class="yt-title-container">
        <div class="yt-title">{{ title }}</div>
      </div>
    </div>
    <b-modal v-model="isModalActive">
      <div class="modal-container">
        <h4 class="modal-title">{{ title }}</h4>
        <iframe
          id="lessonPlayerDiv"
          allow="fullscreen; accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          :title="title"
          width="100%"
          height="468"
          :src="
            `https://www.youtube.com/embed/${videoId}?autoplay=1&enablejsapi=1&origin=https%3A%2F%2Fplay.chesssquad.com&widgetid=1&modestbranding=1`
          "
        >
        </iframe>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { YoutubeAPI } from "../../services/api";

export default {
  name: "YoutubeVideo",
  props: ["videoId"],
  data() {
    return {
      title: "",
      embedHtml: "",
      isModalActive: false,
    };
  },
  methods: {
    openVideo() {
      this.isModalActive = true;
    },
  },
  created() {
    YoutubeAPI.getVideo(this.videoId).then((videoInfo) => {
      this.title = videoInfo.title;
      this.embedHtml = videoInfo.html;
    });
  },
};
</script>
<style scoped>
.yt-video {
  display: flex;
  flex-direction: column;
}
.yt-title-container {
  text-align: center;
  background-color: black;
  color: white;
  padding: 5px 10px;
  min-height: 58px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.yt-title {
  height: 100%;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.yt-thumbnail {
  width: 100%;
  vertical-align: middle;
}
.modal >>> .modal-content {
  max-width: 864px !important;
  margin: 0;
}
.modal-title {
  font-size: 20px;
  color: #ffffff;
  padding-bottom: 16px;
}
</style>
